import { SvgIcon } from '@progress/kendo-react-common';
import React, { useContext } from 'react';
import * as svg from '@progress/kendo-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate } from 'react-router-dom';
import { Card, CardBody, CardFooter, CardHeader } from '@progress/kendo-react-layout';
import { RevUserContext, RevUserContextType, useCurrentUserContext } from '../../../context/UserContext';
import createTheme from '../../../styles/themes';

const TicketNotFound: React.FC = () => {
    const nav = useNavigate();
    const { profile } = useContext<RevUserContextType>(RevUserContext)
    const pageThemeCSS = createTheme(profile.Body_Hex_Color, profile?.Body_Style, profile?.Body_Image_Url);
    const { profile: userProfile } = useCurrentUserContext();

    return (
        <div className='flex flex-grow' style={pageThemeCSS}>
            <div className=" w-auto mt-3 m-auto">
                <Card>
                    <CardHeader className='alert alert-warning'>
                        <div className='flex' style={{ alignItems: 'center', textAlign: 'center' }}>
                            <SvgIcon icon={svg.warningCircleIcon} size='xxlarge' />

                            <h1 style={{ width: '100%', fontSize: '2em', marginBottom: '20px', marginLeft: '20px' }}>Oops! <br />404 - {userProfile?.Phrases.CallPhrase} Not Found</h1>
                            <i style={{ width: '32px' }}></i>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <p style={{ fontSize: '1.5em' }}>The {userProfile?.Phrases.CallPhrase} you are looking for does not exist, has been removed or you do not have permissions to view it.</p>
                    </CardBody>
                    <CardFooter >
                        <Button onClick={() => nav(-2)} size='large'>&lt; Go Back</Button>
                    </CardFooter>
                </Card >
            </div>
        </div>
    );
};

export default TicketNotFound;
